import { useState } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Text } from 'foundations-components/components/Text';
import { Select } from 'foundations-components/transitional/components/Select';
import { Spacer } from 'foundations-components/components/Spacer';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useHistory } from 'react-router-dom';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CourseUnavailableModal({
  availableLanguages
}) {
  const history = useHistory();
  const [selectedLanguage, setSelectedLanguage] = useState();
  const languageOptions = availableLanguages.map(lang => ({
    text: LanguageNames[lang.toLowerCase()] || lang,
    value: lang.toLowerCase()
  }));
  const [__, setSearchParams] = useSearchParams();
  const handleContinue = () => {
    if (selectedLanguage) {
      setSearchParams({
        language: selectedLanguage
      });
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    display: "flex",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.deprecations.notAvailableShort"
        })
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.deprecations.archivedWithLanguageOptions"
      }), /*#__PURE__*/_jsx(Spacer, {
        display: "block"
      }), /*#__PURE__*/_jsx(Select, {
        onChange: event => {
          setSelectedLanguage(event.target.value);
        },
        options: languageOptions,
        placeholder: I18n.text('learningCenter.tracks.deprecations.selectLanguage'),
        value: selectedLanguage
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: !selectedLanguage,
        onClick: handleContinue,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.deprecations.continue"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: () => history.replace('/'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.deprecations.academyHome"
        })
      })]
    })]
  });
}